Set latency correction manually. When recording, a positive latency correction
will remove the set amount from the beginning of the audio, and a negative
latency correction will add to the beginning of the audio.
